import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import BaseService from "../base/BaseService";

export default class CourseService extends BaseService {
    getTitleValueCoursesActive(baseId: number, fieldId: number): Promise<TitleValue<number>[]> {
        return axios.get("/Courses/" + baseId + "/" + fieldId)
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }

    getCourseList(): Promise<TitleValue<number>[]> {
        return axios.get("/Courses/TitleValues/Student")
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }
    
    getCourseListByFieldId(fieldId: number): Promise<TitleValue<number>[]> {
        return axios.get(`/Courses/TitleValues/Student/${fieldId}`)
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }
}